(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.controller.core
  (:require
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.controller.debt-financing
    :refer [debt-financing]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.controller.details-and-figures
    :refer [details-and-figures]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.controller.financial-performance
    :refer [financial-performance]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.controller.financial-statements
    :refer [financial-statements]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.controller.overview
    :refer [overview]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.controller.tearsheet
    :refer
    [tearsheet]]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.common.controller :as re]))

(defn ->ui-data
  [{:keys [dynamic-data report-data map-topo] :as props}]
  {:fund-name (:fund-name report-data)
   :reference-date (:reference-date report-data)
   :tearsheet (tearsheet (update props :dynamic-path concat [:tearsheet]))
   :overview (overview (update props :dynamic-path concat [:overview]))
   :financial-performance (financial-performance
                           (update props :dynamic-path concat [:financial-performance]))
   :debt-financing (debt-financing (update props :dynamic-path concat [:debt-financing]))
   :esg (re/esg (update props :dynamic-path concat [:esg]))
   :details-and-figures (details-and-figures
                         (update props :dynamic-path concat [:details-and-figures]))
   :financial-statements (financial-statements
                          (update props :dynamic-path concat [:financial-statements]))
   :risk-assessment-text (report-ctl/rich-content props :risk-assessment-text)})
